// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPublicV1ChatsBulkOperationsDeleteAllFromSectionDesktopRequestSchema {
  /** Секция, из которой нужно удалить все чаты **/
  section: ESection;
}

export enum ESection {
  /** Раздел "Архив" **/
  'Archive' = 'archive',
  /** Раздел "Сообщения" **/
  'Main' = 'main',
  /** Раздел "Непрочитанные" **/
  'Unread' = 'unread',
}
